import { render, staticRenderFns } from "./Synopsis.vue?vue&type=template&id=031da9d8"
import script from "./Synopsis.vue?vue&type=script&lang=js"
export * from "./Synopsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports